import { NodeCategoryModel } from 'src/modules/network-configuration/models/node-data';
import {
  IConfigurationSrc,
  IConfigurationMirroring,
} from 'src/types/configuration';

export const configurationMirroring = ({
  nodeId,
  nodeCategory,
}: {
  nodeId: string;
  nodeCategory: NodeCategoryModel;
}): IConfigurationMirroring => {
  const defaultSrc: IConfigurationMirroring = {
    dest: -1,
    src: [],
    version: 1,
  };

  const defaultSrcItem: IConfigurationSrc = {
    interface: 0,
    state: 'normal',
  };

  const srcItem: IConfigurationSrc[] = [];
  if (!nodeCategory.ports) return defaultSrc;

  for (let i = 0; i < nodeCategory.ports?.length; i += 1) {
    const port = nodeCategory.ports[i];
    const { portIndexes } = nodeCategory;
    const portIndex = portIndexes[port.id] || 0;
    if (!portIndex) {
      throw new Error('Port index not found');
    }
    const srcItemData = {
      ...defaultSrcItem,
      interface: portIndex,
    };

    srcItem.push(srcItemData);
  }

  defaultSrc.src = srcItem.sort((a, b) => a.interface - b.interface);

  return defaultSrc;
};
